import { BaseCurrencyConversion } from './base-currency-conversion';
import { Entity } from './entity';
import { CurrencyScale } from './enums/currency-scale';

export class CurrencyConversion extends BaseCurrencyConversion {
  localCurrencyScale: CurrencyScale;
  legalEntity: Entity;
}
